import { toast } from 'react-toastify'

export function toastSuccess(message, autoClose = 5000) {
  toast.success(message, { autoClose })
}

export function toastError(message, autoClose = 5000) {
  toast.error(message, { autoClose })
}
